import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Container, Row, Col, Form, Button, Alert } from 'react-bootstrap';
import { MapPin, Phone, Mail } from 'lucide-react';
import './ContactUs.css';
import contactHeroImg from '../../assets/ContactUsPictures/contactUsImg1.jpg';

const ContactUs = () => {
    const location = useLocation();
    const section3Ref = useRef(null);
    const [loadTime] = useState(Date.now());

    const [formData, setFormData] = useState({
        name: '',
        email: location.state?.prefillEmail || '',
        subject: '',
        message: '',
        website: ''
    });

    const [status, setStatus] = useState({ type: '', msg: '' });

    useEffect(() => {
        if (location.state?.prefillEmail) {
            section3Ref.current?.scrollIntoView({ behavior: 'smooth' });
        }
    }, [location]);

    const handleInputChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus({ type: '', msg: '' });
        setIsSubmitting(true);

        //  Spam protection
        const timeTaken = (Date.now() - loadTime) / 1000;
        if (timeTaken < 5 || formData.website !== "") {
            console.warn("Spam protection triggered.");
            setStatus({ type: 'success', msg: 'Your message has been sent successfully!' });
            return;
        }

        const dataForPhp = {
            name: formData.name,
            email: formData.email,
            applicationType: formData.subject,
            reason: formData.message,
            website: formData.website
        };

        try {
            const [phpResponse, nodeResponse] = await Promise.allSettled([
                //fetch("https://infinitiemployment.com/api-portal/send-contact.php", {
                fetch("/send-contact.php", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(dataForPhp),
                }),
                //fetch("http://localhost:5000/api/messages", {
                fetch("/api-portal/messages", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        name: formData.name,
                        email: formData.email,
                        subject: formData.subject,
                        message: formData.message
                    }),
                })
            ]);

            // Check success with dashboard (Node.js)
            let nodeSuccess = false;
            if (nodeResponse.status === 'fulfilled') {
                const nodeData = await nodeResponse.value.json();
                nodeSuccess = nodeData.success;
            }

            if (nodeSuccess) {
                setStatus({ type: 'success', msg: 'Thank you! Your message has been received.' });
                setFormData({ name: '', email: '', subject: '', message: '', website: '' });
            } else {
                throw new Error('Submission failed');
            }

        } catch (err) {
            setStatus({
                type: 'danger',
                msg: 'We are sorry, but your message could not be sent due to a technical error. Please try again later.'
            });
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="contact-us-page">

            {/* Section 1 ------------------------------------------------------------------ */}
            <section
                className="contact-hero-section"
                style={{ backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.40), rgba(0, 0, 0, 0)), url(${contactHeroImg})` }}
            >
                <Container className="h-100 d-flex align-items-center justify-content-center">
                    <div className="contact-hero-content text-center text-white">

                        <h1 className="contact-title mb-3">Contact Us</h1>

                        <p className="contact-subtitle">
                            This quest has led us to be a Multi-Awarded & Professional team that never forgets where they come from and always listen and adapts. Aesthetics, ergonomics, design should all be use to serve a purpose.
                        </p>

                        <div className="contact-divider mx-auto mb-3"></div>

                    </div>
                </Container>
            </section>

            {/* Section 1 ------------------------------------------------------------------ */}

            {/* Section 2 ------------------------------------------------------------------ */}
            <section className="map-section w-100 p-0 overflow-hidden">
                <iframe
                    title="Infiniti Location"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3504.606822458448!2d-81.3468925!3d28.5515233!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88e770308c339591%3A0xc6f5f3e4ec919790!2s3218%20E%20Colonial%20Dr%20Suite%20F%2C%20Orlando%2C%20FL%2032803!5e0!3m2!1sen!2sus!4v1700000000000!5m2!1sen!2sus"
                    width="100%"
                    height="450"
                    style={{ border: 0, display: 'block' }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
            </section>
            {/* Section 2 ------------------------------------------------------------------ */}

            {/* Section 3: Contact Form & Info ---------------------------------------------- */}
            <section ref={section3Ref} className="contact-info-section py-5">
                <Container>
                    <Row className="g-5">
                        <Col lg={7}>
                            <div className="contact-form-wrapper p-4 p-md-5 shadow-sm rounded">
                                <h3 className="section-title-small mb-4">Send us a Message</h3>

                                {status.msg && <Alert variant={status.type}>{status.msg}</Alert>}

                                <Form onSubmit={handleSubmit}>
                                    <div style={{ display: 'none' }} aria-hidden="true">
                                        <input
                                            type="text"
                                            name="website"
                                            value={formData.website}
                                            onChange={handleInputChange}
                                            tabIndex="-1"
                                            autoComplete="off"
                                        />
                                    </div>

                                    <Row className="g-3">
                                        <Col md={6}>
                                            <Form.Group>
                                                <Form.Label>YOUR NAME</Form.Label>
                                                <Form.Control
                                                    name="name"
                                                    required
                                                    value={formData.name}
                                                    onChange={handleInputChange}
                                                    placeholder="Name"
                                                    className="custom-input-field"
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={6}>
                                            <Form.Group>
                                                <Form.Label>SUBJECT</Form.Label>
                                                <Form.Control
                                                    name="subject"
                                                    required
                                                    value={formData.subject}
                                                    onChange={handleInputChange}
                                                    placeholder="Subject"
                                                    className="custom-input-field"
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={12}>
                                            <Form.Group>
                                                <Form.Label>EMAIL ADDRESS</Form.Label>
                                                <Form.Control
                                                    name="email"
                                                    type="email"
                                                    required
                                                    value={formData.email}
                                                    onChange={handleInputChange}
                                                    placeholder="Email Address"
                                                    className="custom-input-field"
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={12}>
                                            <Form.Group>
                                                <Form.Label>MESSAGE</Form.Label>
                                                <Form.Control
                                                    name="message"
                                                    as="textarea"
                                                    rows={5}
                                                    required
                                                    value={formData.message}
                                                    onChange={handleInputChange}
                                                    placeholder="Message"
                                                    className="custom-input-field"
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={12}>
                                            <Button type="submit" className="btn-send-message px-5 py-3 text-uppercase fw-bold" disabled={isSubmitting}>
                                                {isSubmitting ? 'Sending...' : 'Send Message'}
                                            </Button>
                                        </Col>
                                    </Row>
                                </Form>
                            </div>
                        </Col>

                        {/* Right Col: Contact info */}
                        <Col lg={5}>
                            <div className="contact-details-card custom-margin-top">
                                <h3 className="section-title-small mb-4">Get In Touch</h3>

                                <div className="info-item d-flex mb-4">
                                    <div className="info-icon me-3">
                                        <MapPin size={24} />
                                    </div>
                                    <div>
                                        <h5 className="mb-1">Our Office</h5>
                                        <p className="text-muted">3218 E. Colonial Drive Suite F, Orlando, FL 32803</p>
                                    </div>
                                </div>

                                <div className="info-item d-flex mb-4">
                                    <div className="info-icon me-3">
                                        <Phone size={24} />
                                    </div>
                                    <div>
                                        <h5 className="mb-1">Phone Number</h5>
                                        <p className="text-muted">407-894-2199</p>
                                    </div>
                                </div>

                                <div className="info-item d-flex mb-4">
                                    <div className="info-icon me-3">
                                        <Mail size={24} />
                                    </div>
                                    <div>
                                        <h5 className="mb-1">Email Address</h5>
                                        <p className="text-muted">info@infinitiemployment.com</p>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </div>
    );
};

export default ContactUs;